/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from "@components";
import { Panel, Text } from "@design-system";
import { type FC } from "react";
import { HiOutlinePlus, HiOutlineX } from "react-icons/hi";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  buttonText?: string;
  buttonClick?: () => void;
  secondaryButtonText?: string;
  secondaryButtonClick?: () => void;
  buttonIcon?: "plus" | "x" | "none";
  buttonColor?: "primary" | "gray" | "red";
}

export const EmptyState: FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  buttonText,
  buttonClick,
  secondaryButtonText,
  secondaryButtonClick,
  buttonIcon = "none",
  buttonColor = "primary"
}) => {
  const getButtonIcon = () => {
    switch (buttonIcon) {
      case "plus":
        return <HiOutlinePlus className="mr-2 h-5 w-5" />;
      case "x":
        return <HiOutlineX className="mr-2 h-5 w-5" />;
      case "none":
      default:
        return null;
    }
  };

  return (
    <Panel
      variant="compact"
      className="flex flex-col items-center justify-center h-full p-6 text-center"
    >
      {icon && <div className="mb-4">{icon}</div>}
      <Text as="h3" variant="heading-lg" className="mb-2 text-xl">
        {title}
      </Text>
      {description && (
        <Text variant="muted" className="mb-4 max-w-md mx-auto">
          {description}
        </Text>
      )}
      {buttonText && buttonClick && (
        <div className="flex gap-3">
          <Button color={buttonColor} size="sm" onClick={buttonClick}>
            {getButtonIcon()}
            {buttonText}
          </Button>
          {secondaryButtonText && secondaryButtonClick && (
            <Button color="light" size="sm" onClick={secondaryButtonClick}>
              {secondaryButtonText}
            </Button>
          )}
        </div>
      )}
    </Panel>
  );
};
